/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Auth from "../../shared/Auth";
import { qreq } from "../../shared/qrequest";
import BaseCom from "../BaseCom";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";
import './Dashboard.css';
import CM2PerDayChart from "../chart/CM2PerDayChart";
import CM2PerMonthChart from "../chart/CM2PerMonthChart";
import PhaseChart from "../chart/PhaseChart";
import LifecycleDash from "../chart/LifecycleDash";
import Globals from "../../shared/Globals";
import Card from "../Card";
import OrderProducts from "../OrderProducts";
import WoundTypeBreakdownChart from "../chart/WoundTypeBreakdownChart";
import Roundup from "./Roundup";
import { Link } from "react-router-dom";
import GenDashboard from "./GenDashboard";
import MnfDashboard from "./MnfDashboard";

export class CardPrimary extends BaseCom {
    render() {
        return <div className={`card-primary --bg-primary ${this.props.className ? ' ' + this.props.className : ''}`}>
            <div className="card-header">{this.props.title}</div>
            <div className="card-body">
                {this.props.children}
            </div>
        </div>;
    }
}

export class CardSecondary extends BaseCom {
    render() {
        return <div className={'card-secondary --bg-secondary' + (this.props.className ? ' ' + this.props.className : '')}>
            <div className="card-header">{this.props.title}</div>
            <div className="card-body">
                {this.props.children}
            </div>
        </div>;
    }
}

class Meters extends BaseCom {
    componentDidMount() {
        qreq.get('/api/dashboard/meter/list', j => {
            if (j.list)
                this.setState({ meters: j.list });
        });
    }

    render() {
        return <div className="meter-list">
            {this.state.meters?.map(i => <div className="meter">
                <div className="counter --bg-primary">{i.counter}</div>
                <div className="label --text-primary">{i.label}</div>
            </div>)}
        </div>;
    }
}

class ProvidersWidget extends BaseCom {
    componentDidMount() {
        qreq.post('/api/provider/list', {}, j => {
            if (j.list)
                this.setState({ list: j.list });
        });
    }

    render() {
        return <div className="providers-widget --bg-secondary">
            {this.state.list?.map(i => <div className="card-white d-flex align-items-center">
                <div className="avatar"><img src={Globals.getImageURL(i.photoURL)} alt="" /></div>
                <div className="info ms-2">
                    <div className="name">{i.firstName} {i.lastName}</div>
                    <div className="specialty text-muted">{i.specialty}</div>
                </div>
            </div>)}
        </div>;
    }

}

class NewDashboard extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            user: null
        };
    }

    async componentDidMount() {
        Auth.getLogin(u => {
            this.setState({ user: u });
        });
        await this.getSettings();
    }

    render() {
        if(this.state.MODEL === 'GEN')
            return <GenDashboard />;
        else if(this.state.MODEL === 'MNF')
            return <MnfDashboard />;


        return <div className="Dashboard container-fluid">
            <h1>Dashboard</h1>
            <h2>Good <span>{Globals.getTimeOfDay()}</span> {this.state.user?.name}!</h2>
            {this.state.MODEL === 'WMS' && <>
                <div className="row">
                    <div className="col-lg-9 mt-3">
                        <CardSecondary title="Dashboard Overview">
                            <Meters />
                        </CardSecondary>
                        {Auth.hasRole('manager') && <CardPrimary title="Roundup" className="mt-3">
                            <div className="p-2">
                                <Roundup />
                            </div>
                        </CardPrimary>}
                        <div className="row">
                            <div className="col-lg mt-3">
                                <CardPrimary title={<>Wounds by Type</>}>
                                    <WoundTypeBreakdownChart />
                                </CardPrimary>
                            </div>
                            <div className="col-lg mt-3">
                                <CardPrimary title={<>Total Patients in Phase</>}>
                                    <PhaseChart />
                                </CardPrimary>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 mt-3">
                        <CardSecondary title="Care Team Providers">
                            <ProvidersWidget />
                        </CardSecondary>
                        <CardSecondary title="Resources" className="mt-3">
                            <div className="d-grid gap-1">
                                <Link to="/asset-library" className="btn btn-lg btn-primary">Asset Library</Link>
                            </div>
                        </CardSecondary>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg mt-3">
                        <CardPrimary title={<>Total cm<sup>2</sup> per day (30 days)</>}>
                            <CM2PerDayChart />
                        </CardPrimary>
                    </div>
                    <div className="col-lg mt-3">
                        <CardPrimary title={<>Total cm<sup>2</sup> per month</>}>
                            <CM2PerMonthChart />
                        </CardPrimary>
                    </div>
                </div>


                <div className="row">
                    <div className="col-lg-12 mt-3">
                        <LifecycleDash />
                    </div>
                </div>

                <Card title="Products" className="mt-3">
                    <OrderProducts />
                </Card>
            </>}
        </div>;
    }
}

export default withParamsAndNavigate(NewDashboard);